let authContext = null;
let isUnauthorizedRedirectInProgress = false;
let lastForbiddenNoticeAt = 0;
const FORBIDDEN_NOTICE_COOLDOWN_MS = 1200;

const isAuthPage = () => {
  const pathname = window.location.pathname;
  return (
    pathname === '/' ||
    pathname === '/login' ||
    pathname.startsWith('/auth/callback') ||
    pathname.startsWith('/auth/google/callback')
  );
};

const redirectToLogin = () => {
  if (isAuthPage() || isUnauthorizedRedirectInProgress) {
    return;
  }

  isUnauthorizedRedirectInProgress = true;
  window.location.replace('/login');
};

export const setAuthContext = (context) => {
  authContext = context;
};

const notifyForbidden = () => {
  const now = Date.now();

  if (now - lastForbiddenNoticeAt < FORBIDDEN_NOTICE_COOLDOWN_MS) {
    return;
  }

  lastForbiddenNoticeAt = now;

  if (authContext?.handleForbidden) {
    authContext.handleForbidden('Недостаточно прав');
    return;
  }

  window.dispatchEvent(
    new window.CustomEvent('creative-platform:forbidden', {
      detail: { message: 'Недостаточно прав' },
    }),
  );
};

export const fetchWithAuth = async (url, options = {}) => {
  const apiTarget = import.meta.env?.VITE_API_TARGET || 'http://localhost:5174';
  const fullUrl = url.startsWith('http') ? url : `${apiTarget}${url}`;
  
  try {
    const response = await fetch(fullUrl, {
      ...options,
      credentials: 'include',
    });
    options.signal?.throwIfAborted();
    
    if (response.status === 401) {
      if (authContext?.handleUnauthorized) {
        authContext.handleUnauthorized();
      }

      redirectToLogin();

      const unauthorizedError = new Error('Unauthorized');
      unauthorizedError.name = 'UnauthorizedError';
      unauthorizedError.status = 401;
      throw unauthorizedError;
    }

    if (response.status === 403) {
      notifyForbidden();
    }
    
    return response;
  } catch (error) {
    if (error?.status === 401 || error?.name === 'UnauthorizedError' || error?.message === 'Unauthorized') {
      throw error;
    }
    throw error;
  }
};
